<p-table
  [value]="displayedResults()"
  [rows]="displayedResults?.length"
  [tableStyle]="{ 'min-width': '50rem' }"
  (sortFunction)="sortResults($event)"
  [customSort]="true"
  [sortField]="sortField"
  [sortOrder]="sortOrder"
  sortMode="single"
  selectionMode="single"
  styleClass="p-datatable-md"
  [showInitialSortBadge]="false">
  <ng-template #header>
    <tr>
      <ng-container *ngFor="let column of columns">
        <th *ngIf="column.code !== 'path' && column.sortable" [pSortableColumn]="column.code">
          {{ column.name }}<p-sortIcon [field]="column.code"></p-sortIcon>
        </th>
        <th *ngIf="column.code !== 'path' && !column.sortable" class="p-sortable-column cursor-auto">
          {{ column.name }}
        </th>
      </ng-container>
    </tr>
  </ng-template>
  <ng-template #body let-item>
    <ng-container *ngIf="!loading && !pageLoading; else rowPlaceholder">
      <tr>
        <ng-container *ngFor="let column of columns">
          <td *ngIf="column.code !== 'path'" class="p-0 font-normal">
            <ng-container *ngIf="item?.path?.value | decodeUrl as url">
              <a
                [routerLink]="url.segments"
                [queryParams]="url.queryParams"
                class="py-2-5 block w-full px-4 text-gray-700 no-underline"
                (click)="onRowClicked(item)">
                <ng-container [ngSwitch]="item[column.code]?.type">
                  <ng-container *ngSwitchCase="'STATUS'">
                    <p-tag
                      [style]="{
                        color: item[column.code]?.color | lightenDarkenColor,
                        background: item[column.code]?.color
                      }"
                      value="{{ item[column.code]?.value }}"
                      styleClass="text-xs flex-nowrap whitespace-nowrap px-2-5 py-1">
                      <ng-template pTemplate="icon" *ngIf="item[column.code]?.icon">
                        <i
                          class="{{ item[column.code]?.icon }} text-sm"
                          [style]="{
                            color: (item[column.code]?.color | lightenDarkenColor) + ' !important'
                          }"></i>
                      </ng-template>
                    </p-tag>
                  </ng-container>
                  <ng-container *ngSwitchCase="'ICON'">
                    <i
                      [class]="item[column.code]?.icon"
                      [ngStyle]="{ color: item[column.code]?.color }"
                      [title]="item[column.code]?.value"
                      style="font-size: 1rem"
                      class="mr-1"></i>
                  </ng-container>
                  <ng-container *ngSwitchCase="'LIST'">
                    <div *ngIf="item[column.code]?.listItems.length" class="flex max-w-52 flex-row items-center">
                      <div class="overflow-hidden text-ellipsis whitespace-nowrap">
                        <div
                          *ngFor="let listItem of item[column.code]?.listItems; let last = last"
                          [ngClass]="{ 'mb-1': !last }"
                          class="overflow-hidden text-ellipsis">
                          <i [class]="listItem.icon + ' w-1-25rem mr-1 text-center text-base text-gray-600'"></i>
                          <span> {{ listItem.value }}</span>
                        </div>
                      </div>
                      <p-badge
                        *ngIf="item[column.code]?.totalNumberOfListItems > item[column.code]?.listItems.length"
                        [value]="
                          '+ ' + (item[column.code]?.totalNumberOfListItems - item[column.code]?.listItems.length)
                        "
                        styleClass="ml-2 mb-1 p-badge-xs p-badge-secondary whitespace-nowrap" />
                    </div>
                  </ng-container>
                  <ng-container *ngSwitchCase="'EMPTY'">
                    <span>-</span>
                  </ng-container>
                  <ng-container *ngSwitchDefault>
                    <span [innerHTML]="item[column.code]?.value"></span>
                  </ng-container>
                </ng-container>
              </a>
            </ng-container>
          </td>
        </ng-container>
      </tr>
    </ng-container>
  </ng-template>
  <ng-template #sorticon field="col.field" let-sortOrder>
    <ng-container *ngIf="sortOrder === 1 && sortField">
      <i
        class="p-sortable-column-icon p-sortable-column-icon-custom fa-solid fa-arrow-up text-gray-700"
        aria-hidden="true"></i>
    </ng-container>
    <ng-container *ngIf="sortOrder === -1 && sortField">
      <i
        class="p-sortable-column-icon p-sortable-column-icon-custom fa-solid fa-arrow-down text-gray-700"
        aria-hidden="true"></i>
    </ng-container>
  </ng-template>
</p-table>

<div class="p-4">
  <app-table-paginator
    [rows]="rows"
    [first]="first"
    [totalRecords]="totalRecords"
    [alwaysShow]="false"
    [showFirstLastIcon]="true"
    (changePage)="onChangePage($event)"
    (changeRows)="onChangeRowCount($event)"></app-table-paginator>
</div>

<ng-template #rowPlaceholder>
  <tr>
    <td *ngFor="let column of columns">
      <p-skeleton width="100%" styleClass="p-2"></p-skeleton>
    </td>
  </tr>
</ng-template>
